import size from "../sizes";
import sublimationPrinting from "./templates/sublimation-printing";
import image1 from "../../assets/images/materials/mask/1.jpg";
import image2 from "../../assets/images/materials/mask/2.jpg";
import image3 from "../../assets/images/materials/mask/3.jpg";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>
          Маска с принтом выполнена их двух слоев ткани. 
          Мягкий 100% хлопок внутри приятен в носке и не вызывает аллергии. 
          Верхний слой выполнен из 100% полиэстера, что позволяет создавать яркие изображения. 
          Наши маски не защищают от вирусов, но помогают выразить свою индивидуальность.
        </p>
        <p>Не является медицинским изделием!</p>
        <p>
          Состав внутреннего материала: 100% хлопок<br>
          Состав внешнего материала: 100% полиэстер
        </p>
      `,
      images: [
        {
          source: image1,
          captionContent: {
            title: `100% хлопок внутри`,
            description: `Мягкий 100% хлопок внутри приятен в носке и не вызывает аллергии.`
          }
        },
        {
          source: image2,
          captionContent: {
            title: `100% полиэстер снаружи`,
            description: `Верхний слой выполнен из 100% полиэстера, что позволяет создавать яркие изображения.`
          }
        },
        {
          source: image3,
          captionContent: {
            title: `Сертификат соответствия`,
            description: `Наши маски прошли добровольную сертификацию и могут применяться для защиты от внешних воздействий. При их изготовлении мы руководствуемся ТУ Росстандарта.`
          }
        }
      ]
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`mask`]
    }
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
